export const menuOptionsSortPaper = {
  trending: "Trending",
  new: "Newest",
  old: "Oldest"
};
export const menuOptionsSortModel = {
  likes: "popularity",
  trending: "trending",
  downloads: "downloads",
  new: "new",
  size: "size"
};
export const modelSort = Object.entries(menuOptionsSortModel);
